import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { InviteTokenDataObject } from 'models/service';

// TODO this belongs somewhere else, once we need to reuse
export const getInvitationToken = async (invitationToken: string) =>
  apiClient.get<InviteTokenDataObject, ApiClientResponse<InviteTokenDataObject>>(
    routes.tokens.getInvitationToken(invitationToken),
  );
